<template>
  <div class="flex flex-col items-center justify-center gap-4">
    <div class="block h-2 w-full rounded-full bg-gray-350">
      <span
        :style="{
          animationDuration: `${animationDuration}s`,
        }"
        class="block h-full animate-bar-fill rounded-full bg-process-active"
      ></span>
    </div>
    <div>{{ loadingText }}</div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  loadingText: {
    type: String,
    required: true,
  },
  animationDuration: {
    type: Number,
    required: false,
    default: 10,
  },
})

const emit = defineEmits(['loaded'])

const timerId = ref()

onMounted(() => {
  timerId.value = setTimeout(
    () => emit('loaded'),
    props.animationDuration * 1000,
  )
})
onUnmounted(() => clearTimeout(timerId.value))
</script>
